import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private message$ = new Subject<string | null>();

  /** Emits when a toast should be shown. Null means hide. */
  readonly toast$ = this.message$.asObservable();

  show(message: string): void {
    this.message$.next(message);
  }

  hide(): void {
    this.message$.next(null);
  }
}
